import {   Ref, onUnmounted, ref } from 'vue';
import { useIntersectionObserver, useEventListener } from '@vueuse/core';

/**
 * @description 统计元素在组件内停留时长
 * @param  elementRef 需要监听的元素
 * @param  onStayEnd 停留时间结束时的回调函数，参数为进入和离开视图(包括刷新和跳转界面)的停留时间（单位：秒）
 */
export function useStayTimebrow(elementRef:  Ref<HTMLDivElement | null>,  onStayEnd: (time: number) => void) {
  // ---- data ----
  let startTime: null|Date = null;
  let endTime: null|Date = null;
  const timeInView = ref(0);
  const target = ref(elementRef);
  const setTimeInView = () => {
    endTime  = new Date();
    if (startTime !== endTime  && startTime !== null) {
      timeInView.value  = Math.floor((endTime.getTime() - startTime.getTime()) / 1000);
      if (timeInView.value  > 0) {
        onStayEnd(timeInView.value);
      }
      startTime  = null;
      endTime = null;
    }
  };

  // 处理元素进入和离开视图的方法
  const handleIntersection = (entries: IntersectionObserverEntry[]): void => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
      // 元素进入视图
        startTime  = new Date();
      } else {
      // 元素离开视图
        setTimeInView();
      }
    });
  };

  // 注册指定元素进入视图范围的监听事件
  const { stop } = useIntersectionObserver(
    target,
    handleIntersection,
  );
  // 注册页面离开前的监听事件
  const cleanup = useEventListener(window, 'beforeunload', setTimeInView);

  onUnmounted(() => {
    // 删除页面离开前监听事件
    cleanup();
    // 停止元素进入视图范围的监听事件
    stop();
    // 停止监听的回调函数
    onStayEnd(timeInView.value);
  });
  return {

  };
}
